export default "__VITE_ASSET__nEnAOIiy1F$rRbwro1m6dg__"